import { render, staticRenderFns } from "./customformfield.vue?vue&type=template&id=4bbf9eb1&"
import script from "./customformfield.vue?vue&type=script&lang=js&"
export * from "./customformfield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports